/** @format */
import angular from 'angular';
import _ from 'lodash';
import { commonCurriculumPeriodServiceModule } from '../service/curriculumPeriod.service';
import { TooltipComponent } from '../tooltip/tooltip.component';
import template from './curriculumPeriodsCompact.tpl.html';

controller.$inject = ['commonCurriculumPeriodService'];

export const curriculumPeriodsCompactComponentModule = 'sis-components.curriculumPeriod.curriculumPeriodsCompact';

angular
    .module(curriculumPeriodsCompactComponentModule, [
        commonCurriculumPeriodServiceModule,
        'sis-components.date.yearRangeFilter',
        TooltipComponent.downgrade.moduleName,
    ])
    .component('curriculumPeriodsCompact', {
        template,
        controller,
        bindings: {
            curriculumPeriodIds: '<',
            disableTooltip: '<',
        },
    });

function controller(commonCurriculumPeriodService) {
    const ctrl = this;
    ctrl.curriculumPeriods = [];
    ctrl.yearRange = null;

    ctrl.$onChanges = changesObj => {
        const curriculumPeriodIds = _.get(changesObj, 'curriculumPeriodIds.currentValue');
        if (_.isEmpty(curriculumPeriodIds)) {
            ctrl.curriculumPeriods = [];
            ctrl.yearRange = null;
        } else {
            commonCurriculumPeriodService
                .findCurriculumPeriodsByIds(curriculumPeriodIds)
                .then(curriculumPeriods => _.sortBy(curriculumPeriods, 'activePeriod.startDate'))
                .then(curriculumPeriods => Object.assign(ctrl, { curriculumPeriods }));
            commonCurriculumPeriodService
                .getCurriculumPeriodYearRange(curriculumPeriodIds)
                .then(yearRange => Object.assign(ctrl, { yearRange }));
        }
    };
}
